import * as api from '@/api/feature'
import Feature from '@/store/models/feature'

export let state = {
  feature: new Feature,
  featureList: []
}

export let mutations = {
  setfeatureList: (state, payload) => state.featureList = payload,

  reset: state => state.feature = new Feature,
  setFeature: (state, payload) => state.feature = (new Feature).hydrate(payload),
  setTitle: (state, payload) => state.feature.title = payload,
  setBody: (state, payload) => state.feature.body = payload
}

export let actions = {

  all: ({ commit }) => new Promise((resolve, reject) => {
    api.all(response => {
      commit('setfeatureList', response.data)
      resolve()
    }, reject)
  })

}